<template>
  <div class="px-6">
    <o-custom-fields :data="reservation.customFields">
      <template #default="{fields}">
        <o-description-details
          v-for="field in fields"
          :key="field.props.id"
          :term="field.label"
        >
          <component
            :is="field.component"
            v-bind="field.props"
            v-on="field.events"
          />
        </o-description-details>
      </template>
    </o-custom-fields>
  </div>
</template>

<script setup lang="ts">
import {
  OCustomFields,
  ODescriptionDetails,
} from '@/components/elements'

interface Props {
  reservation?: object | null
}

withDefaults(defineProps<Props>(), {
  reservation: null,
})
</script>
